import type { AppRouteRecordRaw } from "#src/router/types";

/**
 * Adds a unique ID to the route object, replacing the automatically generated ID. This ID defaults to the route's path.
 * {
 * path: '/dashboard',
 * }
 *
 * After conversion:
 *
 * {
 * path: '/dashboard',
 * id: '/dashboard',
 * }
 */
export function addRouteIdByPath(routes: AppRouteRecordRaw[], parentId = "") {
	return routes.map((route) => {
		// If it is an index route, the ID is the parent path + "/"
		const newRoute = { ...route, id: route.index ? `${parentId}/` : route.path };

		if (newRoute.children && newRoute.children.length > 0) {
			newRoute.children = addRouteIdByPath(newRoute.children, route.path);
		}

		return newRoute;
	});
}
